import { Record as record, List as list } from 'immutable';

import { construct, resolveAll } from '../helpers/LinkMapper';
import Station from './Station';
import { StationTypes } from '../constants/AppConstants';

const defaults = {
    [StationTypes.ORIGIN]: list([]),
    [StationTypes.DESTINATION]: list([]),
    [StationTypes.VIAAVOID]: list([])
};

class RecentStations extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(RecentStations, json, {
            [StationTypes.ORIGIN]: resolveAll.as(Station),
            [StationTypes.DESTINATION]: resolveAll.as(Station),
            [StationTypes.VIAAVOID]: resolveAll.as(Station)
        });
    }

}

export default RecentStations;



// WEBPACK FOOTER //
// ./src/records/RecentStations.js